import { render, staticRenderFns } from "./HasGiftButton.vue.html?vue&type=template&id=9929280a&"
import script from "./HasGiftButton.component.js?vue&type=script&lang=vueJs&"
export * from "./HasGiftButton.component.js?vue&type=script&lang=vueJs&"
import style0 from "./HasGiftButton.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports